import { connect } from 'react-redux';
import { publishAllToSAP } from 'common/gantt/containers/gantt-actions';
import PublishButton from '../components/planning-board-publish-button';
import { updateView } from '../../worklist/containers/worklist-actions';

const mapStateToProps = state => ({
  totalCount: state.gantt.amountPlanningsToPublish,
  totalErrorCount: state.gantt.amountPlanningsWithPublishingError,
  isLoading: state.gantt.isDoingAction,
  isCreating: state.dynamicToolbar.isCreating,
  isLoadingPublishButton: state.gantt.isLoadingPublishButton,
  views: state.worklist.views,
});

const mapDispatchToProps = {
  publishAllToSAP,
  updateView,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PublishButton);
